module.exports = __webpack_public_path__ + "img/CREDIT CARDS.f4fbd854.png";